export const remoteDBUrl = process.env.REACT_APP_COUCHDB_URL || process.env.REACT_APP_VAN_COUCHDB_URL || ''
export const apiGatewayKey = process.env.REACT_APP_API_GATEWAY_KEY || ''
export const apiGatewayUrl = process.env.REACT_APP_API_GATEWAY_URL || ''



// WEBPACK FOOTER //
// ./src/helpers/config.js